import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconProfileDefaultFill = ({
  width = 40,
  height = 40,
  ...props
}: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 40 40'
      {...props}
    >
      <defs>
        <clipPath id='circle-clip'>
          <circle cx='20' cy='20' r='20' />
        </clipPath>
      </defs>
      <g clipPath='url(#circle-clip)'>
        <path fill='#8E98A0' fillOpacity={0.15} d='M0 0h40v40H0z' />
        <path
          d='M19.997 20.5c2.272 0 4.37.595 5.974 1.6 1.598 1.003 2.763 2.455 3.014 4.176.126.861-.54 1.452-1.168 1.665-4.178 1.42-10.738 1.405-15.523-.003-.655-.193-1.425-.792-1.277-1.722l.061-.317c.358-1.566 1.478-2.887 2.973-3.816 1.6-.995 3.687-1.583 5.946-1.583zM20 11a4.25 4.25 0 110 8.5 4.25 4.25 0 010-8.5z'
          fill='#8E98A0'
          fillOpacity={0.6}
        />
      </g>
    </svg>
  )
}

export default memo(IconProfileDefaultFill)
